import {
  InputGroup,
  Input,
  InputRightElement,
  ThemingProps,
  Text,
  Box,
} from '@chakra-ui/react'
import { ViewOffIcon, ViewIcon } from '@chakra-ui/icons'
import React from 'react'

interface FormInputProps {
  value?: string | number
  onChange?: (e: React.ChangeEvent<any>) => void
  useToggle?: boolean
  placeholder?: string
  size?: ThemingProps['size']
  variant?: ThemingProps['variant']
  name: string
  error?: string
  type?: string
  textAlign?: 'left' | 'center' | 'right' | 'justify'
  disabled?: boolean
  className?: string
  label?: string
  labelColor?: string
  borderRadius?: string
  readonly?: boolean
  labelClassName?: string
  focusBorderColor?: string
}

const FormInput = ({
  value,
  onChange,
  useToggle = false,
  placeholder,
  size = 'md',
  name,
  error,
  type = 'text',
  variant,
  textAlign = 'left',
  disabled,
  className,
  label,
  labelColor = 'black',
  borderRadius = 'md',
  readonly,
  labelClassName,
  focusBorderColor = 'black',
}: FormInputProps) => {
  const [hidePassword, setHidePassword] = React.useState(true)

  const handleToggle = () => {
    setHidePassword(!hidePassword)
  }

  const inputType =
    type === 'password' && useToggle ? (hidePassword ? 'password' : 'text') : type

  return (
    <Box textAlign={textAlign} w="full" className={className}>
      {label && (
        <p
          className={`pb-3 text-lg font-medium ${labelClassName}`}
          style={{ color: labelColor }}
        >
          {label}
        </p>
      )}
      <InputGroup size={size} variant={variant}>
        <Input
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          type={inputType}
          name={name}
          disabled={disabled}
          size={size}
          borderRadius={borderRadius}
          readOnly={readonly}
          focusBorderColor={focusBorderColor}
          className={`placeholder:text-xs md:placeholder:text-base `}
        />
        {useToggle && type === 'password' && (
          <InputRightElement onClick={handleToggle} cursor="pointer">
            {hidePassword ? <ViewOffIcon color="black" /> : <ViewIcon color="black" />}
          </InputRightElement>
        )}
      </InputGroup>
      {error && (
        <Text color="red" fontSize="xs" paddingLeft="5">
          {error}
        </Text>
      )}
    </Box>
  )
}

export default FormInput
